<template>
    <HeaderNavLink
        :url="component.url"
        class="grid-component-button text-grey-darker flex justify-center items-center bg-white focus:ring"
        :class="`style-${component.style}`"
    >
        <slot name="icon" />
        <span>
            <slot>{{ component.label }}</slot>
        </span>
    </HeaderNavLink>
</template>

<script>
import Spinner from '~/components/Spinner';
import HeaderNavLink from '@/components/HeaderNavLink';

export default {

    components: {
        HeaderNavLink,
        Spinner,
    },

    props: {
        component: {
            type: Object,
            default: () => { },
        },
    },

};
</script>

<style lang="scss" scoped>
.grid-component-button {
    @apply px-4 md:px-6 py-2 md:py-4 transition-fast select-none flex text-center leading-tight font-heading font-normal;

    &:hover {
        &:not(:disabled) {
            @apply opacity-75 shadow-md;
        }
    }

    &:disabled {
        @apply opacity-50 cursor-default;
    }

    @media (max-width: config("theme.screens.sm")) {
        @apply px-1;
        font-size: 90%;
        min-height: 2.5rem;
        height: auto;
    }
}
</style>
